/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { appState, setAlert, setLoading } from '../../slices/appSlice';
import { getEvidencias, instrumentoServicesState, obtenerInstrumentoMedicionConvocatoria } from '../../slices/instrumentoServiceSlice';
import { registroConvocatoriaState } from '../../slices/registroConvocatoriaSlice';

import { ReactComponent as UploadIcon } from '../../assets/icons/upload.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg';
import { ReactComponent as MoreIcon } from '../../assets/icons/more.svg';
import { ReactComponent as InfoIcon } from '../../assets/icons/info.svg';

import { ALERT_FAIL, ALERT_SUCCESS, CVE_TIPODOC_CEMEFI } from '../../app/constantes';
import { deleteEvidenciaRespuestaNm, deleteRespuestaInstrumento, deleteRespuestaInstrumentoNMRegistro, getInstrumentoRegistroEvidencia, postEvidenciaDocument, postEvidenciaNMDocument, postEvidenciaNMRespuesta, postPreguntaRespuestaInstrumentoRegistro, putEvidenciaNMRespuesta, putEvidenciaRespuesta } from '../../services/instrumento';
import { findCatalogById, getBase64 } from '../../app/commons';
import { getDocument } from '../../services/entidad';
import { useEffect } from 'react';
import ConfirmModal from '../generales/confirmModal';
import { catalogosServiceState, getTipoDocumentoCemefi } from '../../slices/catalogosServiceSlice';

export default function SubirEvidencia({ saveFirebaseProgress, respuestaRegistrada, tipoRespuesta, nivelMadureza, getCounters, deleteFile, descartarNivel, onlyView }) {
    const dispatch = useDispatch();
    const appSt = useSelector(appState);
    const convocatoriaSt = useSelector(registroConvocatoriaState);
    const instrumentoSt = useSelector(instrumentoServicesState);
    const catalogosSt = useSelector(catalogosServiceState);
    const registroConvocatoriaSt = useSelector(registroConvocatoriaState);
    const {respuestaSeleccionada} = instrumentoSt;
    const [modalData, setModalData] = useState({
        show: false,
        title: '',
        desc: '',
        info: null,
        list: null
    });

    // Cierra Modal de confirmacion
    const closeModal = () => {
        setModalData({
            ...modalData,
            show: false
        })
    }

    // Confirmar Continuar
    // const confirmDelete = (evidencia) => {
    //     console.log(instrumentoSt.lastProgress, respuestaRegistrada)
    //     if (instrumentoSt.lastProgress > respuestaRegistrada.valorRespuesta) {
    //         setModalData({
    //             show: true,
    //             title: 'Eliminar Evidencia',
    //             desc: '¿Al eliminar la evidencia se borraran las evidencias subsecuentes?',
    //             info: evidencia,
    //             action: () => deleteAllEvidences(evidencia)
    //         })
    //     } else {
    //         deleteFile(evidencia);
    //         console.log('eliminar')
    //     }
    // }

    /**
     * Descargamos una evidencia
     * @param {*} evidencia 
     */
    const downloadFile = async (evidencia, item) => {
        console.log(evidencia)
        if (!evidencia.includes('AREA/')) {
            console.log('no contiene url')
            uploadNewDoc(evidencia, item)
        } else {
            console.log('pasa normal')
            dispatch(setLoading(true));
            const docResp = await getDocument({
                ...appSt.serviceData,
                idEntidad: convocatoriaSt.empresaSeleccionada.idEntidad,
                idContent: evidencia
            });
    
            if (docResp.payload) {
                // const type = docResp.tipoArchivo === 'pdf' ? 'data:application/pdf' : `data:image/${docResp.tipoArchivo}`;
                const type = 'data:image/png'
                const file64 = docResp.payload.base64;
                const linkSource = `${type};base64,${file64}`;
                const downloadLink = document.createElement('a');
                const fileName = getEvidenciaName(evidencia);
    
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                dispatch(setLoading(false));
            }
        }
    }

    const handleNMSave = async (files) => {
        try {
            dispatch(setLoading(true));
            const body = {
                idInstrumentoRegistro: instrumentoSt.preguntaSeleccionada.idInstrumentoRegistro,
                idPreguntaIndicador: instrumentoSt.preguntaSeleccionada.idPreguntaIndicador,
                idRespuesta: respuestaSeleccionada.idRespuesta,
                cveNivelMadurez: findCatalogById(nivelMadureza, catalogosSt.nivelMadurez, 'idNivelMadurez', 'cveNivelMadurez'),
                descRespuesta: respuestaSeleccionada.descRespuesta,
                isEvidencia: respuestaSeleccionada.isEvidencia,
                idRespuestaNivelMadurez: respuestaSeleccionada.idRespuestaNivelMadurez,
                idRespuestaInstrumentoRegistro: respuestaSeleccionada.idRespuestaInstrumentoRegistro
            }
            const resp = await postPreguntaRespuestaInstrumentoRegistro({...appSt.serviceData, body})
            const data = {
                ...appSt.serviceData,
                idTipoEntidad: registroConvocatoriaSt.empresaSeleccionada.idTipoEntidad,
                idTamanio: registroConvocatoriaSt.empresaSeleccionada.idTamanio,
                idRegistroConvocatoria: registroConvocatoriaSt.convocatoriaSeleccionada.idRegistroConvocatoria,
            }
            await uploadNMFiles(files, resp);
            dispatch(setLoading(false));
            dispatch(obtenerInstrumentoMedicionConvocatoria({ ...data, query: instrumentoSt.query }));
            saveFirebaseProgress();

            dispatch(setAlert({
                show: true,
                message: 'Respuesta Guardada',
                type: ALERT_SUCCESS
            }))

        } catch (error) {
            console.log(error);
            dispatch(setLoading(false));
            dispatch(setAlert({
                show: true,
                message: 'Error al Guardar Respuesta',
                type: ALERT_SUCCESS
            }))
        }
    }

    const uploadNewDoc = async (evidencia, item) => {
        try {
            const dataEvidencia = {
                ...appSt.serviceData,
                idEntidad: convocatoriaSt.empresaSeleccionada.idEntidad,
                idInstrumentoRegistro: instrumentoSt.preguntaSeleccionada.idInstrumentoRegistro,
                idPreguntaInstrumentoRegistro: respuestaRegistrada.idPreguntaInstrumentoRegistro,
                idRespuestaInstrumentoRegistro: respuestaRegistrada.idRespuestaInstrumentoRegistro,
            }
            const body = {
                cveTipoDocumento: 'EVIDENCIA',
                cveDocumentoCemefi: respuestaRegistrada.idRespuestaNmInstrumentoRegistro ? CVE_TIPODOC_CEMEFI.evidenciaNm : CVE_TIPODOC_CEMEFI.evidencia,
                archivo: {
                    nombreArchivo: evidencia,
                    tipo: 'application/pdf',
                    base64: "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"
                }
            }
            console.log(respuestaRegistrada, instrumentoSt.respuestaSeleccionada)
            const respDoc = await postEvidenciaNMDocument({
                ...dataEvidencia,
                idRespuestaNivelMadurez: respuestaRegistrada.idRespuestaNivelMadurez,
                idRespuestaNMInstrumentoRegistro: respuestaRegistrada.idRespuestaNmInstrumentoRegistro,
                idEvidenciaRespuestaNM: item.idEvidenciaRespuestaNm
            }, body);
    
            await putEvidenciaNMRespuesta({
                ...appSt.serviceData,
                idEvidenciaRespuestaNm: item.idEvidenciaRespuestaNm
            }, { evidencia: respDoc.contentId })     
            
            downloadFile(respDoc.contentId)
        } catch (error) {
            console.log(error)
            dispatch(setAlert({
                show: true,
                message: 'Error al descargar evidencia',
                type: ALERT_FAIL
            }))
            
        }
    }

    const uploadNmDoc = async (dataEvidencia, respNm, resp, body) => {
        try {
            const respDoc = await postEvidenciaNMDocument({
                ...dataEvidencia,
                idRespuestaNivelMadurez: respNm.respuestaNivelMadurez.idRespuestaNivelMadurez,
                idRespuestaNMInstrumentoRegistro: respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro,
                idEvidenciaRespuestaNM: resp.id
            }, body);
    
            await putEvidenciaNMRespuesta({
                ...appSt.serviceData,
                idEvidenciaRespuestaNm: resp.id
            }, { evidencia: respDoc.contentId })            
        } catch (error) {
            console.log('no subio archivo', error, respuestaRegistrada, respNm)
            await deleteEvidenciaRespuestaNm({
                ...appSt.serviceData,
                idEvidenciaRespuestaNm: resp.id
            })
            const respRgs = await getInstrumentoRegistroEvidencia({...appSt.serviceData, idRespuestaNmInstrumentoRegistro: respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro})
            if (respRgs && respRgs.length === 0) {
                await deleteRespuestaInstrumento({
                    ...appSt.serviceData,
                    idRespuestaInstrumentoRegistro: resp.idRespuestaInstrumentoRegistro,
                })
                await deleteRespuestaInstrumentoNMRegistro({
                    ...appSt.serviceData,
                    idRespuestaNmInstrumentoRegistro: respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro,
                })

            }
            dispatch(setAlert({
                show: true,
                message: 'Error al subir evidencia',
                type: ALERT_FAIL
            }));
            dispatch(setLoading(false));
            const data = {
                ...appSt.serviceData,
                idTipoEntidad: convocatoriaSt.empresaSeleccionada.idTipoEntidad,
                idTamanio: convocatoriaSt.empresaSeleccionada.idTamanio,
                idRegistroConvocatoria: convocatoriaSt.convocatoriaSeleccionada.idRegistroConvocatoria,
            }
            dispatch(obtenerInstrumentoMedicionConvocatoria({ ...data, query: instrumentoSt.query }));
            throw Error('Error al subir evidencia')
        }
    }

    const uploadNMFiles = async (items, respNm) => {
        const files = items
        if (files && files.length > 0) {
            dispatch(setLoading(true));
            [...files].forEach(async (file) => {                
                const base64 = await getBase64(file);
                const body = {
                    cveTipoDocumento: 'EVIDENCIA',
                    cveDocumentoCemefi: respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro ? CVE_TIPODOC_CEMEFI.evidenciaNm : CVE_TIPODOC_CEMEFI.evidencia,
                    archivo: {
                        nombreArchivo: file.name,
                        tipo: file.type,
                        base64: base64
                    }
                }

                try {
                    const evidenciaBody = {
                        idDocumentoCemefi:respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro ? catalogosSt.idsTipoDocumentoCemefi.evidenciaNm : catalogosSt.idsTipoDocumentoCemefi.evidencia,
                        evidencia: file.name
                    }

                    let resp = await postEvidenciaNMRespuesta(appSt.serviceData, {
                        ...evidenciaBody,
                        idRespuestaNmInstrumentoRegistro: respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro
                    });

                    const dataEvidencia = {
                        ...appSt.serviceData,
                        idEntidad: convocatoriaSt.empresaSeleccionada.idEntidad,
                        idInstrumentoRegistro: instrumentoSt.preguntaSeleccionada.idInstrumentoRegistro,
                        idPreguntaInstrumentoRegistro: respNm.preguntaInstrumentoRegistro.idPreguntaInstrumentoRegistro,
                        idRespuestaInstrumentoRegistro: respNm.respuestaInstrumentoRegistro.idRespuestaInstrumentoRegistro,
                    }

                    await uploadNmDoc(dataEvidencia, respNm, resp, body)                    

                    dispatch(setAlert({
                        show: true,
                        message: 'Documento Cargado',
                        type: ALERT_SUCCESS
                    }));

                    dispatch(setLoading(false));
                    getCounters();
                    dispatch(getEvidencias({ ...appSt.serviceData, idRespuestaNivelMadurez: respNm.respuestaNmInstrumentoRegistro.idRespuestaNmInstrumentoRegistro, type: 'nm' }));

                } catch (error) {                    
                    console.log(error, 'error generico')
                    dispatch(setAlert({
                        show: true,
                        message: 'Error al subir evidencia',
                        type: ALERT_FAIL
                    }));
                    dispatch(setLoading(false));
                }
            })
            const data = {
                ...appSt.serviceData,
                idTipoEntidad: convocatoriaSt.empresaSeleccionada.idTipoEntidad,
                idTamanio: convocatoriaSt.empresaSeleccionada.idTamanio,
                idRegistroConvocatoria: convocatoriaSt.convocatoriaSeleccionada.idRegistroConvocatoria,
            }
            dispatch(obtenerInstrumentoMedicionConvocatoria({ ...data, query: instrumentoSt.query }));
        }
    }

    /**
     * Subimos una evidencia
     * @param {*} e 
     */
    const uploadFile = async (e) => {
        const files = e.target.files;
        
        const maxSize = 10000000;
        [...files].forEach(async file => {
            if (file.size > maxSize) {
                dispatch(setAlert({
                    show: true,
                    message: 'El archivo supera los 10MB',
                    type: ALERT_FAIL
                }))
                dispatch(setLoading(false));
                return
            } else {
                await handleNMSave(files);
            }
        })
    }

    // Se actualiza un archivo
    const updateFile = async (e, evidencia) => {
        const files = e.target.files;
        if (files[0]) {
            dispatch(setLoading(true));
            const file = files[0];
            const base64 = await getBase64(file);
            const body = {
                cveTipoDocumento: 'EVIDENCIA',
                cveDocumentoCemefi: 'EVIDENCIA',
                archivo: {
                    nombreArchivo: file.name,
                    tipo: file.type,
                    base64: base64
                }
            }
            try {
                const dataEvidencia = {
                    ...appSt.serviceData,
                    idEntidad: convocatoriaSt.empresaSeleccionada.idEntidad,
                    idInstrumentoRegistro: instrumentoSt.preguntaSeleccionada.idInstrumentoRegistro,
                    idPreguntaInstrumentoRegistro: respuestaRegistrada.idPreguntaInstrumentoRegistro,
                    idRespuestaInstrumentoRegistro: respuestaRegistrada.idRespuestaInstrumentoRegistro,
                }
    
                if (respuestaRegistrada.idRespuestaNmInstrumentoRegistro) {
                    const respDoc = await postEvidenciaNMDocument({
                        ...dataEvidencia,
                        idRespuestaNivelMadurez: respuestaRegistrada.idRespuestaNivelMadurez,
                        idRespuestaNMInstrumentoRegistro: respuestaRegistrada.idRespuestaNmInstrumentoRegistro,
                        idEvidenciaRespuestaNM: evidencia.idEvidenciaRespuestaNm
                    }, body);
    
                    await putEvidenciaNMRespuesta({
                        ...appSt.serviceData,
                        idEvidenciaRespuestaNm: evidencia.idEvidenciaRespuestaNm
                    }, { evidencia: respDoc.contentId })
                } else {
                    const respDoc = await postEvidenciaDocument({
                        ...dataEvidencia,
                        idEvidenciaRespuesta: evidencia.idEvidenciaRespuesta
                    }, body);
    
                    await putEvidenciaRespuesta({
                        ...appSt.serviceData,
                        idEvidenciaRespuesta: evidencia.idEvidenciaRespuesta
                    }, { evidencia: respDoc.contentId })
                }
                const data = {
                    ...appSt.serviceData,
                    idTipoEntidad: convocatoriaSt.empresaSeleccionada.idTipoEntidad,
                    idTamanio: convocatoriaSt.empresaSeleccionada.idTamanio,
                    idRegistroConvocatoria: convocatoriaSt.convocatoriaSeleccionada.idRegistroConvocatoria,
                }
                dispatch(obtenerInstrumentoMedicionConvocatoria({ ...data, query: instrumentoSt.query }));
                dispatch(setLoading(false));
                dispatch(setAlert({
                    show: true,
                    message: 'Documento Actualizado',
                    type: ALERT_SUCCESS
                }))                
            } catch (error) {
                dispatch(setLoading(false));
                dispatch(setAlert({
                    show: true,
                    message: 'Error al actualizar documento',
                    type: ALERT_FAIL
                }))                
            }
            
            e.target.value = '';
        }
    }

    const getEvidenciaName = (filePath) => {
        const path = filePath.split('/');
        return path.slice(-1);
    }

    /**
     * Llamos el servicio para obtener las evidencias dependiendo si la respuesta es de tipo nivel de madurez o no
     */
    useEffect(() => {
        if (respuestaRegistrada && tipoRespuesta !== catalogosSt.idsTipoRespuesta.nivelMadurez) {
            dispatch(getEvidencias({ ...appSt.serviceData, idRespuestaInstrumentoRegistro: respuestaRegistrada.idRespuestaInstrumentoRegistro, type: 'normal' }));
        } else if (respuestaRegistrada && tipoRespuesta === catalogosSt.idsTipoRespuesta.nivelMadurez) {
            console.log(respuestaRegistrada)
            dispatch(getEvidencias({ ...appSt.serviceData, idRespuestaNivelMadurez: respuestaRegistrada.idRespuestaNmInstrumentoRegistro, type: 'nm' }));
        }
        console.log(respuestaRegistrada, instrumentoSt.respuestaSeleccionada)
    }, [instrumentoSt.respuestaSeleccionada])
    
    // useEffect(() => {
    //     if (!appSt.loading && !instrumentoSt.loading && respuestaSeleccionada.valorRespInstrReg && filesToUpload && filesToUpload.length > 0) {
    //         uploadWaitingFiles();
    //     }

    // }, [respuestaSeleccionada, filesToUpload])

    useEffect(() => {
        dispatch(getTipoDocumentoCemefi(appSt.serviceData));
    }, [])

    return <div className="evidencia-wrapper">
        {instrumentoSt.instrumento && !onlyView &&
            <div className="upload">
                <div className="desc">
                    <UploadIcon />
                    <p>Subir evidencia</p>
                </div>
                <input onChange={(e) => uploadFile(e)} type="file" />
                {tipoRespuesta !== catalogosSt.idsTipoRespuesta.opcionMultiple &&
                    <div className="tip">
                        <InfoIcon />
                        <p><b>Evidencia Sugerida:</b> {respuestaRegistrada.descRespuesta}</p>
                    </div>
                        
                }
            </div>        
        }
        <div className="evidencias">
            <p>Evidencias Cargadas</p>
            <div className="wrap">
                {instrumentoSt.evidencias && instrumentoSt.evidencias.length > 0 && instrumentoSt.evidencias.map((evidencia, index) => {
                    return evidencia.idEstatusRegistro !== 0 && <div key={index} className='file'>
                        <button onClick={() => downloadFile(evidencia.evidencia, evidencia)}>
                            <DownloadIcon />
                        </button>
                        <p>{getEvidenciaName(evidencia.evidencia)}</p>
                        {instrumentoSt.instrumento && !onlyView &&
                            <div className='more-menu'>
                                <MoreIcon />
                                <ul className="sub-menu">
                                    {tipoRespuesta === catalogosSt.idsTipoRespuesta.nivelMadurez &&
                                        <li onClick={() => descartarNivel(evidencia)}>
                                            <DeleteIcon />
                                            <p>Eliminar</p>
                                        </li>
                                    }
                                    {tipoRespuesta !== catalogosSt.idsTipoRespuesta.nivelMadurez &&
                                        <li onClick={() => deleteFile(evidencia)}>
                                            <DeleteIcon />
                                            <p>Eliminar</p>
                                        </li>
                                    }
                                    <li className='upload-update'>
                                        <input type="file" onChange={(e) => updateFile(e, evidencia)}/>
                                        <UploadIcon />
                                        <p>Reemplazar</p>
                                    </li>
                                </ul>
                            </div>                        
                        }
                    </div>
                })}
            </div>
        </div>
        <ConfirmModal data={modalData} cancel={closeModal} />
    </div>
}